import { AxiosInstance } from 'axios';
import { IQuoteServiceVariableData } from '@/models';
import { IQuoteServiceVariableService } from './quote-service-variable.types';

export class QuoteServiceVariableService
  implements IQuoteServiceVariableService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/quotes/templates/services/variables/';
  }

  fetchQuoteServiceVariables(): Promise<IQuoteServiceVariableData[]> {
    return this.axios.get(`${this.endpoint}`).then(({ data }) => data);
  }

  fetchQuoteServiceVariable(id: number): Promise<IQuoteServiceVariableData> {
    return this.axios.get(`${this.endpoint}${id}/`).then(({ data }) => data);
  }

  createQuoteServiceVariable(
    data: IQuoteServiceVariableData
  ): Promise<IQuoteServiceVariableData> {
    return this.axios.post(`${this.endpoint}`, data).then(({ data }) => data);
  }

  updateQuoteServiceVariable(
    data: IQuoteServiceVariableData
  ): Promise<IQuoteServiceVariableData> {
    return this.axios
      .patch(`${this.endpoint}${data.id}/`, data)
      .then(({ data }) => data);
  }

  deleteQuoteServiceVariable(id: number): Promise<void> {
    return this.axios.delete(`${this.endpoint}${id}/`).then(({ data }) => data);
  }
}
